import { trigger, animate, transition, style } from '@angular/animations';

//* pop up animation

export const modalOpen = trigger('modalOpen', [
  transition('void => *', [style({ transform: 'scale3d(.3, .3, .3)' }), animate(100)]),
  transition('* => void', [animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))]),
]);
